



























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import controller from '@/app/ui/controllers/DropBoxController'
import { DropBox } from '@/domain/entities/DropBox'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import EmptyState from '@/app/ui/components/EmptyState/EmptyState.vue'
import DropBoxMonitoringListRow from '@/app/ui/views/DropBox/Monitoring/ListRow.vue'
import { Utils } from '@/app/infrastructures/misc'

const ITEMS_PER_PAGE = 10
const REFRESH_INTERVAL_MS = 10 * 60 * 1000

interface IParams {
  page: number
  perPage: number
  search: string | null
}

interface IParamsData extends IParams {
  sort: { label: string; value: string }
  status: string | null
  visibility: string | null
  agentCode: string | null
  serialNumber: string | null
  externalId: string | null
}

interface IParamsValue {
  [key: string]: string | number | boolean | null | undefined
  page: number
  limit: number
  name?: string
  sort_by: string
  sort_order: string
  status?: string
  visibility?: string
  agent_code?: string
  serial_number?: string
  external_id?: string
}

@Component({
  components: {
    TextInput,
    DropdownSelect,
    PaginationNav,
    EmptyState,
    DropBoxMonitoringListRow,
  },
})
export default class DropBoxMonitoringPage extends Vue {
  controller = controller

  refreshTimerId: ReturnType<typeof setInterval> | null = null

  sortOptions = [
    { label: 'Newest', value: 'desc' },
    { label: 'Oldest', value: 'asc' },
  ]

  parameters: IParamsData = {
    page: 1,
    perPage: ITEMS_PER_PAGE,
    search: null,
    sort: this.sortOptions[0],
    status: null,
    visibility: null,
    agentCode: null,
    serialNumber: null,
    externalId: null,
  }

  get canAccessDropBoxDetail(): boolean {
    return Utils.isSuperAdmin()
  }

  created(): void {
    if (this.$route.query instanceof Object) {
      const queries = this.$route.query as Record<string, string | undefined>
      const limit =
        Utils.alwaysNumber(queries.limit ?? '') ||
        Utils.alwaysNumber(queries.perPage ?? '')
      const sortOrder = queries.sort_order || queries.sort || ''
      const search = queries.name || queries.search || null

      this.parameters = {
        page: Utils.alwaysNumber(queries.page ?? '') || 1,
        perPage: limit || ITEMS_PER_PAGE,
        search,
        sort:
          this.sortOptions.find(item => item.value === sortOrder) ||
          this.sortOptions[0],
        status: queries.status || null,
        visibility: queries.visibility || null,
        agentCode: queries.agent_code || null,
        serialNumber: queries.serial_number || null,
        externalId: queries.external_id || null,
      }
    }
    this.fetchDropBoxMonitoring()
    this.refreshTimerId = setInterval(() => {
      this.fetchDropBoxMonitoring()
    }, REFRESH_INTERVAL_MS)
  }

  beforeDestroy(): void {
    if (this.refreshTimerId !== null) {
      clearInterval(this.refreshTimerId)
      this.refreshTimerId = null
    }
  }

  @Watch('params')
  onParamsChanged(
    val: Record<string, string | number | boolean | null | undefined>
  ): void {
    const query: Record<string, string> = {}
    Object.keys(val).forEach(key => {
      const v = val[key]
      if (v !== undefined && v !== null) {
        query[key] = String(v)
      }
    })

    this.$router.replace({ query }).catch(() => {
      // Ignore NavigationDuplicated errors
    })
  }

  @Watch('parameters.search')
  onKeywordChanged(val: string): void {
    if (val === '') {
      this.fetchDropBoxMonitoring(true)
    }
  }

  get params(): IParamsValue {
    const params: IParamsValue = {
      page: this.parameters.page,
      limit: this.parameters.perPage,
      sort_by: 'updated_at',
      sort_order: this.parameters.sort.value,
    }
    if (this.parameters.search) {
      const searchValue = this.parameters.search.trim()
      if (searchValue) params.name = searchValue
    }
    if (this.parameters.status) params.status = this.parameters.status
    if (this.parameters.visibility)
      params.visibility = this.parameters.visibility
    if (this.parameters.agentCode) params.agent_code = this.parameters.agentCode
    if (this.parameters.serialNumber)
      params.serial_number = this.parameters.serialNumber
    if (this.parameters.externalId)
      params.external_id = this.parameters.externalId
    return params
  }

  get displayList(): DropBox[] {
    return this.controller.dropBoxData
  }

  private fetchDropBoxMonitoring(resetPage = false): void {
    if (resetPage) {
      this.parameters.page = 1
    }
    this.controller.getDropBoxMonitoring(this.params)
  }

  private goToDetail(externalId: string | undefined): void {
    if (!this.canAccessDropBoxDetail || !externalId) return
    this.$router.push({
      path: `/drop-box/${externalId}`,
      query: { origin: 'monitoring' },
    })
  }
}
